import type {
  TScannerCredentialFieldOption,
  TScannerCredentialFieldsMode,
} from '@/_core/entities/scanner-credential-fields/models/types';

export const SCANNER_CREDENTIAL_FIELDS: TScannerCredentialFieldOption[] = [
  { fieldKey: 'email', label: 'Email' },
  { fieldKey: 'username_login', label: 'Username (Login)' },
  { fieldKey: 'phone_number', label: 'Phone number' },
  { fieldKey: 'credit_card', label: 'Credit card' },
  { fieldKey: 'password', label: 'Password' },
  { fieldKey: 'static_otp', label: 'Static OTP' },
  { fieldKey: 'totp_secret_code', label: 'TOTP secret code' },
  { fieldKey: 'secret_word', label: 'Secret word' },
];

export const CUSTOM_FIELD_OPTION: TScannerCredentialFieldOption = {
  fieldKey: 'custom',
  label: 'Custom field',
};

export const DEFAULT_SCANNER_CREDENTIAL_FIELDS_MODE: TScannerCredentialFieldsMode = 'integration';
export const DEFAULT_SCANNER_CREDENTIAL_FIELDS_TITLE = 'Login workflow credentials';
export const DEFAULT_SCANNER_CREDENTIAL_FIELDS_DISABLED_REASON =
  'Pay for the scan to unlock scanner credential fields.';
export const CUSTOM_FIELD_PREFIX = 'custom__';
